import React from "react";
import { TableHeader } from "react-aria-components";
import clsx from "clsx";

import styles from "./table-head.module.css";

interface TableHeadProps {
  children: React.ReactNode;
  className?: string;
  "data-testid"?: string;
}

function TableHead({
  children,
  "data-testid": testId,
  className,
}: TableHeadProps) {
  return (
    <TableHeader
      data-testid={testId}
      className={clsx(styles.tableHead, className)}
    >
      {children}
    </TableHeader>
  );
}

export default TableHead;
